import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=c8f0dc38&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"
import style0 from "./Block.vue?vue&type=style&index=0&id=c8f0dc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0dc38",
  null
  
)

export default component.exports